export const columns = [
  // {
  //   title: "发货编号",
  //   dataIndex: "deliveryTaskCode",
  //   key: "deliveryTaskCode",
  //   rowKey: "deliveryTaskCode",
  // },
  {
    title: "物流单号",
    dataIndex: "logisticsCode",
    key: "logisticsCode",
    rowKey: "logisticsCode",
    scopedSlots:{
      customRender:'logisticsCode'
    }
  },
  {
    title: "货代渠道",
    key: "forwarder",
    dataIndex: "forwarder",
    width:280,
    rowKey: "deliveryTaskCode",
    scopedSlots: {
      customRender: "forwarder",
    },
  },
  {
    title: "发货时间",
    key: "deliveryTime",
    dataIndex: "deliveryTime",
    rowKey: "deliveryTime",
    width: 200,
  },
  {
    title: "总箱数",
    key: "totalBoxNum",
    dataIndex: "totalBoxNum",
    width: 100,
  },
  {
    title: "备注",
    key: "invoicRemark",
    dataIndex: "invoicRemark",
    rowKey: "invoicRemark",
  },
  {
    title: "口座扣税",
    key: "tax",
    dataIndex: "tax",
    rowKey: "tax",
    scopedSlots: {
      customRender: "tax",
    },
  },
  {
    title: "箱子数据",
    key: "boxDetail",
    dataIndex: "boxDetail",
    rowKey: "boxDetail",
    scopedSlots: {
      customRender: "boxDetail",
    },
    // customRender: (text, record, index) => {
    //   return record.boxDetail?`${record.length}*${record.width}*${record.height}-${record.boxNum}-${record.weight}kg`:'';
    // },
  },
  {
    title: "发货件数",
    key: "realDeliveryNums",
    dataIndex: "realDeliveryNums",
    rowKey: "deliveryTaskCode",
    width: 100,
  },
  {
    title: "客户名称",
    key: "customerName",
    dataIndex: "customerName",
    rowKey: "deliveryTaskCode",
    width: 200,
  },
];


export const columns_Action = [
  {
    title: "操作",
    key: "action",
    dataIndex: "action",
    rowKey: "deliveryTaskCode",
    width: 150,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];

// export const columns_waitingProduced = [
//   {
//     title: "备注",
//     key: "managerRemark",
//     dataIndex: "managerRemark",
//     rowKey: 'deliveryTaskCode'
//   },
// ];

export const columns_AlreadyProduced = [
  {
    title: "制作人",
    key: "operatorName",
    dataIndex: "operatorName",
    rowKey: 'deliveryTaskCode'
  },
];


export const columnsSon = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    rowKey: 'id',
    width: 50,
    fixed: "left",
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "国际发货编号",
    dataIndex: "deliveryTaskCode",
    key: "deliveryTaskCode",
    width: 200
  },
  {
    title: "商品图片",
    dataIndex: "productImg",
    key: "productImg",
    rowKey: 'id',
    width: 140,
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  {
    title: "商品标题",
    dataIndex: "productName",
    key: "productName",
    width: 150
  },
  {
    title: "商品SKU",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
    rowKey: 'id',
    width: 180,
    scopedSlots:{
      customRender:'shopProductSku'
    }
  },
  {
    title: "中文品名",
    dataIndex: "productCategoryName",
    key: "productCategoryName",
    width: 150
  },
  {
    title: "编制方式和材质",
    dataIndex: "compilationMethod",
    key: "compilationMethod",
    width: 150
  },
  {
    title: "平台SKU",
    dataIndex: "productSku",
    key: "productSku",
    width: 180,
    rowKey: 'id',
    scopedSlots:{
      customRender:'productSku'
    }
  },
  {
    title: "发货数量",
    dataIndex: "realDeliveryNums",
    key: "deliveryNums",
    rowKey: 'id',
    width: 100,
    customRender: (text) => {
      return text + "件";
    },
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    rowKey: 'id',
    width: 180,
    scopedSlots:{
      customRender:'action'
    },
    fixed: 'right'
  },
];

export const columns_small = [
  {
    title: "物流单号",
    dataIndex: "logisticsCode",
    key: "logisticsCode",
    rowKey: "logisticsCode",
    scopedSlots: {
      customRender: "logisticsCode",
    },
  },
  {
    title: "货代渠道",
    key: "forwarder",
    dataIndex: "forwarder",
    rowKey: "deliveryTaskCode",
    scopedSlots: {
      customRender: "forwarder",
    },
  },
  {
    title: "下单账户主体",
    key: "logisticsCustomerName",
    dataIndex: "logisticsCustomerName",
    rowKey: "logisticsCustomerName"
  },
  {
    title: "发货时间",
    key: "deliveryTime",
    dataIndex: "deliveryTime",
    rowKey: "deliveryTime",
  },
  {
    title: "发货件数",
    key: "realDeliveryNums",
    dataIndex: "realDeliveryNums",
    rowKey: "deliveryTaskCode",
  },
  {
    title: "客户名称",
    key: "customerName",
    dataIndex: "customerName",
    rowKey: "deliveryTaskCode",
  }
]

export const columns_small_already = [
  {
    title: "制作时间",
    dataIndex: "createTime",
    key: "createTime",
    rowKey: "createTime",
  },
  {
    title: "货代渠道",
    key: "wmsIntForwarderConfigId",
    dataIndex: "wmsIntForwarderConfigId",
    rowKey: "wmsIntForwarderConfigId",
    customRender: (text, record, index) => {
      return record.wmsForwarder + record.wmsShippingType;
    },
  },
  {
    title: "下单账户主体",
    key: "logisticsCustomerName",
    dataIndex: "logisticsCustomerName",
    rowKey: "logisticsCustomerName"
  },
  {
    title: "申报抬头",
    key: "title",
    dataIndex: "title",
    rowKey: "title",
  },
  {
    title: "物流单数",
    key: "nums",
    dataIndex: "nums",
    rowKey: "nums",
  },
  {
    title: "发货日期",
    key: "deliveryTimeStr",
    dataIndex: "deliveryTimeStr",
    rowKey: "deliveryTimeStr",
  },
  {
    title: "操作",
    key: "action",
    dataIndex: "action",
    rowKey: "deliveryTaskCode",
    width: 150,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
]
